import React from "react";
import Titre from "../common/Titre";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import com1 from "../../assets/img/com_6.jpeg";
import com2 from "../../assets/img/com_7.jpeg";
import com3 from "../../assets/img/comm_8.jpeg";
import commite4 from "../../assets/img/commite-4.jpeg";
import commite6 from "../../assets/img/commute_1.jpeg";
import commite7 from "../../assets/img/commite_2.jpeg";
import commite8 from "../../assets/img/com_1.jpeg";
import commite9 from "../../assets/img/cimmite_3.jpeg";

export default function CommunauteList({ titre }) {
  const images = [
    commite4,
    commite7,
    commite6,
    com1,
    com2,
    com3,
    commite8,
    commite9,
  ];

  return (
    <>
      {/* Title Section */}
      <Titre
        children={titre ? titre : "NOTRE COMMUNAUTÉ"}
        icon={faGraduationCap}
        soustitre={"Les nouvelles actualités."}
      />

      {/* Image Gallery */}
      <div className="gallery-container">
        {images.map((src, index) => (
          <div className="gallery-item" key={index}>
            <img src={src} alt={`Image ${index + 1}`} />
            <div className="hover-overlay">
              <span className="overlay-text">Galla</span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
